var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCheckOk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_4772)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 40C10 43.9397 10.776 47.8407 12.2836 51.4805C13.7913 55.1203 16.001 58.4274 18.7868 61.2132C21.5726 63.999 24.8797 66.2087 28.5195 67.7164C32.1593 69.224 36.0603 70 40 70C43.9397 70 47.8407 69.224 51.4805 67.7164C55.1203 66.2087 58.4274 63.999 61.2132 61.2132C63.999 58.4274 66.2087 55.1203 67.7164 51.4805C69.224 47.8407 70 43.9397 70 40C70 36.0603 69.224 32.1593 67.7164 28.5195C66.2087 24.8797 63.999 21.5726 61.2132 18.7868C58.4274 16.001 55.1203 13.7913 51.4805 12.2836C47.8407 10.776 43.9397 10 40 10C36.0603 10 32.1593 10.776 28.5195 12.2836C24.8797 13.7913 21.5726 16.001 18.7868 18.7868C16.001 21.5726 13.7913 24.8797 12.2836 28.5195C10.776 32.1593 10 36.0603 10 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 40.0026L36.6667 46.6693L50 33.3359",
    stroke: "#41A1EA",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_4772"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckOk);
export default __webpack_public_path__ + "static/media/icon-check-ok.4fac8beb84e4cdf8add87532d0a1c744.svg";
export { ForwardRef as ReactComponent };